// Boomin' — Login / sign-up interstitial (/public/oauth/instabase)
// Sits between the in-app "ログイン / 新規登録" CTAs and the backend OAuth
// handler at `${API_BASE_URL}/public/oauth/instabase`, so the user sees a
// redesigned landing page instead of falling through to the legacy header.

import React from "react";
import { Helmet } from "react-helmet-async";
import { API_BASE_URL } from "Constants";
import {
  BRAND,
  BRAND_SOFT,
  AppHeader,
  AppFooter,
  PictX,
  useBoominFx,
} from "./shared";

const brand = BRAND;
const brandSoft = BRAND_SOFT;

const startOAuth = () => {
  try {
    const ret = sessionStorage.getItem("boomin_return_to");
    if (ret) {
      localStorage.setItem("nextPage", ret);
      sessionStorage.removeItem("boomin_return_to");
    }
  } catch {
    /* ignore */
  }
  window.location.href = `${API_BASE_URL}/public/oauth/instabase`;
};

export const LoginLandingPage: React.FC = () => {
  useBoominFx();

  return (
    <>
      <Helmet>
        <title>ログイン・新規登録 | Boomin'</title>
        <meta
          name="description"
          content="Boomin'にログイン、または新規登録。instabaseアカウントで、お気に入りのクーポンをいつでも見返せます。"
        />
      </Helmet>
      <AppHeader />
      <div
        style={{
          background: "#FFFBF7",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flex: 1,
            padding: "32px 20px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
          }}
        >
          <div
            style={{
              background: "#fff",
              border: "1px solid #F0E6DC",
              borderRadius: 22,
              padding: "32px 24px 28px",
              textAlign: "center",
              boxShadow: "0 6px 22px rgba(26, 26, 26, 0.04)",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                margin: "0 auto 18px",
                borderRadius: 20,
                background: brandSoft,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PictX name="user" size={32} stroke={brand} strokeWidth={1.8} />
            </div>

            <h1
              style={{
                fontSize: 22,
                fontWeight: 800,
                color: "#1A1A1A",
                margin: 0,
                letterSpacing: "-0.01em",
              }}
            >
              ログイン・新規登録
            </h1>
            <p
              style={{
                marginTop: 10,
                marginBottom: 0,
                fontSize: 13,
                lineHeight: 1.75,
                color: "#666",
              }}
            >
              Boomin'をご利用いただくには、
              <br />
              「instabase」アカウントが必要です。
            </p>

            <div
              style={{
                marginTop: 22,
                padding: "14px 16px",
                background: "#FFFBF7",
                border: "1px solid #F0E6DC",
                borderRadius: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <img
                src="/static/img/instabase_logo.svg"
                alt="instabase"
                width={88}
                height={28}
                style={{ display: "block" }}
              />
            </div>

            <button
              type="button"
              onClick={startOAuth}
              style={{
                marginTop: 22,
                width: "100%",
                background: brand,
                color: "#fff",
                border: 0,
                padding: "14px 20px",
                borderRadius: 999,
                fontSize: 15,
                fontWeight: 800,
                cursor: "pointer",
                boxShadow: `0 10px 24px ${brand}40`,
                letterSpacing: "0.02em",
              }}
            >
              instabaseでアカウント作成・ログイン
            </button>

            <p
              style={{
                marginTop: 18,
                marginBottom: 0,
                fontSize: 11,
                lineHeight: 1.7,
                color: "#999",
              }}
            >
              ボタンを押すと、instabaseの認証画面に移動します。
              <br />
              認証後、Boomin'に自動で戻ります。
            </p>
          </div>

          <a
            href="/"
            style={{
              marginTop: 18,
              alignSelf: "center",
              fontSize: 12,
              fontWeight: 700,
              color: "#888",
              textDecoration: "none",
            }}
          >
            ← トップに戻る
          </a>
        </div>

        <AppFooter />
      </div>
    </>
  );
};
